// 封装的请求方法
import base from './base'
import axios from 'utils/request'

const api = {
    // params: {mobile, realName, channel}
    addKhUser(mobile, realName, channel) {
        return axios({
            url: base.addKhUser,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            params: {
                mobile,
                realName,
                channel
            }
        })
    },

    // 获取图片验证码
    getPicCode() {
        return axios({
            url: base.getPicCode,
            method: 'GET'
        })
    },

    // 开户预约(需要验证码)
    addNew(mobile, realName, channel, picCode) {
        return axios({
            url: base.addNew,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            params: {
                mobile,
                realName,
                channel,
                picCode
            }
        })
    },

    // 开户预约(AES加密)
    add(mobile, realName, channel, picCode) {
        return axios({
            url: base.add,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            params: {
                mobile,
                realName,
                channel,
                picCode
            }
        })
    }

}

export default api